import { Eye, FileCode2, Globe, Layers, Network } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { Reveal } from "./Reveal";

const ITEMS = [
    { icon: Layers, label: "BEP20", key: null },
    { icon: FileCode2, label: "Smart Contract", key: "Smart Contract" },
    { icon: Network, label: "Decentralized", key: "Decentralized" },
    { icon: Globe, label: "Global", key: "Global" },
    { icon: Eye, label: "Transparent", key: "Transparent" },
];

export const TrustStrip = () => {
    const { t } = useLanguage();
    return (
        <div className="border-y border-white/5 bg-nx-alt" data-testid="trust-strip">
            <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-x-8 gap-y-4 px-5 py-6 sm:px-6 lg:px-8">
                {ITEMS.map((item, i) => (
                    <Reveal key={item.label} delay={i * 0.06} y={12}>
                        <div className="flex items-center gap-2.5" data-testid={`trust-item-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
                            <item.icon size={15} strokeWidth={1.5} className="text-nx-lime" aria-hidden="true" />
                            <span className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.2em] text-nx-mute">
                                {item.key ? t(item.key) : item.label}
                            </span>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    );
};
